import { PlateElement } from "platejs/react";

export function Paragraph(props: any) {
  return <PlateElement {...props}>{props.children}</PlateElement>;
}
